let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ggBc0")).then(() => parcelRequire('7Oog3'));